import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

const useLink = () => {
  const history = useHistory();

  const linkTo = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history],
  );

  return linkTo;
};

export default useLink;
